import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from '@angular/router';


export class CacheRouteReuseStrategy extends BaseRouteReuseStrategy {
    private storeRoutes = new Map<string, DetachedRouteHandle>();

    /**
     * Whether the given route should detach for later reuse.
     * Always returns false for `BaseRouteReuseStrategy`.
     * */
    public shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return route.routeConfig?.data?.reuse === true;
    }

    /**
     * A no-op; the route is never stored since this strategy never detaches routes for later re-use.
     */
    public store(
        route: ActivatedRouteSnapshot,
        detachedTree: DetachedRouteHandle,
    ): void {
        this.storeRoutes.set(route.routeConfig?.path, detachedTree);
    }

    /** Returns `false`, meaning the route (and its subtree) is never reattached */
    public shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return !!this.storeRoutes.get(route.routeConfig?.path);
    }

    /** Returns `null` because this strategy does not store routes for later re-use. */
    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return this.storeRoutes.get(route.routeConfig?.path) as DetachedRouteHandle;
    }
}
